import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/collection/data/renames.php
export default {
	run: function(filter, data, config, global) {
		global.crenames = {}
		if (config.ownerType !== F.OWNER_USER) return
		if (!global.resultIndex || !global.resultIndex.length) return
		var sql = 'SELECT collection_id, custom_rename_text FROM custom_rename WHERE user_id = ? AND collection_id IN(' + Util.in(global.resultIndex) + ')'
		var params = [global.ownerID]
		if (config.sessionID !== global.ownerID) sql += ' AND custom_rename_public = 1'
		var rows = DB.query(sql, params)
		for (var i = 0; i < rows.length; i++) {
			global.crenames[rows[i].collection_id] = rows[i].custom_rename_text
		}
	}
}
